<template>
  <router-view />
</template>
<script>
import { defineComponent } from "vue";
import { Parse } from "src/boot/parse";

const APP_VERSION = process.env.APP_VERSION;

export default defineComponent({
  name: "App",
  setup() {
    Parse.Cloud.run("ping")
      .then((res) => console.log("ping - ", res))
      .catch((err) => console.log(err));

    function checkForNewVersion() {
      fetch("/version.json", { method: "HEAD" }) // Use an existing endpoint
        .then((response) => {
          const serverVersion = response.headers.get("X-Release-Version");
          console.log("versions", APP_VERSION, serverVersion);
          if (serverVersion && serverVersion !== APP_VERSION) {
            location.reload(true);
          }
        })
        .catch((error) => console.error("Version check failed:", error));
    }

    // Run the check periodically or on app load
    // setInterval(checkForNewVersion, 300000); // Check every 5 minute
    window.onload = checkForNewVersion;
  },
});
</script>
